module.exports = __webpack_public_path__ + "static/media/withrelay_logo.fe7a406e.png";